"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var actions_1 = require("./actions");
var utils_1 = require("../../utils");
exports.default = (0, utils_1.makeGenericNetworkReducer)(actions_1.FETCH_ASSET_TYPES, actions_1.ADD_ASSET_TYPE, actions_1.UPDATE_ASSET_TYPE);
